import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import SearchApi from '@/services/api/SearchApi'
  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import Badge from '@/components/common/Badge.vue'
  import { useRouter } from 'vue-router/composables'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import type { Nullable } from '@/services/interfaces/Content'
  import type { CourseLessonSearchItem } from '@/services/interfaces/Course'
  import SearchLoader from '@/components/loaders/SearchLoader.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseSearchResults',
  props: {
    searchTerm: {
      required: true,
      type: String,
    },
  },
  setup(__props) {

const props = __props;

  

  const { translateString } = useI18n()
  const router = useRouter()
  const { currentCourseId } = useCourse()
  const { search404 } = useIcons()
  const searchResults = ref(null as Nullable<CourseLessonSearchItem[]>)
  const limit = 10
  const offset = ref(10)

  const searchCrumbs = computed(() => {
    return (item: CourseLessonSearchItem) => {
      const lessonId = item.lesson?.id || item.id
      return [
        {
          url: `/courses/${item.course.id}/info`,
          title: item.course.title,
        },
        {
          url: `/courses/${item.course.id}/module/${item.module.id}`,
          title: item.module.name,
        },
        {
          url: `/courses/${item.course.id}/module/${item.module.id}/lesson/${lessonId}`,
          title: item.lesson?.title || item.title,
        },
      ]
    }
  })

  const toLesson = async (item: CourseLessonSearchItem) => {
    eventBus.$emit('reset-search-term', '')
    const lessonId = item.lesson?.id || item.id
    let path = `/courses/${item.course.id}/module/${item.module.id}/lesson/${lessonId}`
    if (item.type === 'Question') {
      path = `/courses/${item.course.id}/module/${item.module.id}/lesson/${lessonId}/question/${item.id}`
    }
    router.push(path).catch(() => {
      return
    })
  }

  const slicedResults = computed(() => searchResults.value?.slice(0, offset.value) || [])
  const itemSize = computed((): number => {
    return searchResults.value?.length || 0
  })

  const formatExcerpt = (excerpt: string[] | { [key: string]: string[] | string }) => {
    const _excerpt = Object.values(typeof excerpt === 'string' ? [excerpt] : excerpt || []).flat()
    return _excerpt.join('<br>').replaceAll('\\*', '*') || ''
  }

  watch(
    () => props.searchTerm,
    (value: string) => {
      if (value) handleSearch()
    },
  )

  const handleSearch = () => {
    SearchApi.search(props.searchTerm, currentCourseId.value).then((results) => {
      searchResults.value = results as CourseLessonSearchItem[]
    })
  }

  handleSearch()

  const headlineCopy = computed(() => {
    if (!searchResults.value?.length) return `${translateString('search.topResultsText')} "${props.searchTerm}"`
    return `${searchResults.value.length} ${translateString('search.resultsText')} "${props.searchTerm}"`
  })

return { __sfc: true,props, translateString, router, currentCourseId, search404, searchResults, limit, offset, searchCrumbs, toLesson, slicedResults, itemSize, formatExcerpt, handleSearch, headlineCopy, computed, ref, watch, HTMLRenderer, SearchApi, useCourse, useIcons, Badge, useRouter, eventBus, useI18n, SearchLoader }
}

})